<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <!-- <h3 class="title">轮播图</h3> -->
            <div style="padding: 16px 32px 16px 0px">
              <span class="title">轮播图</span>
              <el-button type="primary" size="small" style="float: right" @click="addBanner()">新建</el-button>
            </div>
            <div class="aLine"></div>
            <div class="tableInfo">
              <el-table :data="data_list" @cell-mouse-leave="cellMouseLeave" @cell-mouse-enter="cellMouseEnter">
                <el-table-column prop="order" label="排序" min-width="1"></el-table-column>
                <el-table-column prop="id" label="ID" min-width="1"></el-table-column>
                <el-table-column prop="title" label="轮播图标题" min-width="3"></el-table-column>
                <el-table-column label="图片" min-width="1">
                  <template slot-scope="scope">
                    <el-image style="cursor: pointer; width: 60px; height: 60px" :src="urlPath + scope.row.image_link" fit="cover" :preview-src-list="[urlPath + scope.row.image_link]">
                      <!-- @click="showImage(scope.row)" -->
                      <div slot="error" class="image-slot" style="position: absolute; top: 50%; left: 50%">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="typeStr" label="类型" min-width="1"></el-table-column>
                <el-table-column prop="create_time" label="链接" min-width="1">
                  <template slot-scope="scope"> <img style="cursor: pointer" v-show="scope.row.link.indexOf('http') == 0" src="@/assets/icon_link.png" @click="openLink(scope.row.link)" /> </template
                ></el-table-column>
                <el-table-column prop="statusStr" label="状态" min-width="1"></el-table-column>
                <el-table-column prop="operating" label="操作" min-width="2" align="left">
                  <template slot-scope="scope">
                    <el-button class="operateText" size="mini" type="text" @click="bannerEdit(scope.row)">编辑</el-button>
                    <el-button class="operateText" size="mini" type="text" @click="bannerDelete(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-main>
        <image-dialog ref="_imageDialog"></image-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'
import imageDialog from '@/components/dialog/imageDialog'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    imageDialog
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      urlPath: URL_PATH,
      data_list: [] //数据列表
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.getList()
    },
    // 获取列表
    getList: function () {
      var that = this
      this.$api
        .getBannerList({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.data_list = data.Data
          this.data_list.forEach(info => {
            info.statusStr = StrUtils.getStates(info.status)
            info.typeStr = StrUtils.getType(info.type)
          })
        })
        .catch(({ error }) => {})
    },
    // 显示图片
    showImage(row) {
      this.$nextTick(() => {
        var url = this.$refs._imageDialog.show(this.urlPath + row.image_link)
      })
    },
    // 复制链接
    openLink(link) {
      window.open(link, '_blank')
    },
    // 新建
    addBanner() {
      if (this.data_list.length >= 5) {
        this.$message.error('轮播图最多保存5条记录')
        return
      }
      this.$router.push({
        path: '/wxapp/banner_add'
      })
    },
    // 编辑轮播图
    bannerEdit(row) {
      this.$router.push({
        path: '/wxapp/banner_add',
        query: {
          id: row.id
        }
      })
    },
    // 删除轮播图
    bannerDelete(row) {
      this.$confirm('是否删除此轮播图?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$api
            .delBanner({
              token: localStorage.getItem('token'),
              id: row.id
            })
            .then(({ data }) => {
              this.getList()
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    },
    cellMouseLeave(row, column, cell, event) {},
    cellMouseEnter(row, column, cell, event) {}
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/banners.vue